import { FigureModel, AssetModel } from '../models';

export default function parseEarnings(message, isDiscord) {
  return {
    orderId: message.data?.order_id,
    items: (message.data?.items || []).map(i => AssetModel.fromBasejumpEquipment(i, isDiscord)),
    avatars: (message.data?.avatars || []).map(i => FigureModel.fromBasejumpAvatar(i, isDiscord)),
    xp: message.data?.xp,
    points: message.data?.points,
    note: message.data?.note,
    meta: message.data?.meta,
    completedLevel: message.data?.meta?.level?.order,
    shop_unlocks: message.data?.shop_unlocks?.[0] || null
  };
}
